// Единая точка, через которую конструктор берёт описание карточки.
//
// ЗАЧЕМ. Экрану карточки известна только сущность из адреса — «сделка», «счёт», «судно».
// Он не должен знать, что сделка лежит в `deal.ts`, а счёт в `dokumenty.ts`: разложение по
// файлам — дело удобства чтения, и переложить описание в другой файл должно быть можно, не
// трогая ни одного экрана.
//
// ЧТО СЛОМАЕТСЯ БЕЗ ЭТОГО ФАЙЛА. Каждый экран завёл бы свой импорт напрямую, и добавление
// сущности превратилось бы в обход всех экранов. А `Record<Сущность, ОписаниеКарточки>`
// ниже даёт ещё и проверку типом: забытая сущность — это красный компилятор, а не пустая
// страница у человека.

import type { ОписаниеКарточки, Сущность } from '../types'

import { СДЕЛКА } from './deal'
import { АКТ, ДОГОВОР, ПРОВЕРКА, СЧЁТ } from './dokumenty'
import { КОМПАНИЯ, КОНТАКТ, СОТРУДНИК, СУДНО } from './spravochniki'

/**
 * Все описания. Порядок ключей — порядок, в котором сущности имеет смысл читать:
 * сделка, вокруг которой всё вертится, потом её справочники, потом её документы.
 */
export const ОПИСАНИЯ: Record<Сущность, ОписаниеКарточки> = {
  сделка: СДЕЛКА,
  компания: КОМПАНИЯ,
  контакт: КОНТАКТ,
  судно: СУДНО,
  сотрудник: СОТРУДНИК,
  договор: ДОГОВОР,
  счёт: СЧЁТ,
  акт: АКТ,
  проверка: ПРОВЕРКА,
}

/**
 * Описание сущности.
 *
 * Возвращает, а не ищет: тип `Сущность` закрыт, и промахнуться мимо ключа нельзя — иначе
 * пришлось бы отдавать `undefined` и обрабатывать его на каждом экране.
 */
export function описание(с: Сущность): ОписаниеКарточки {
  return ОПИСАНИЯ[с]
}
